import React from 'react'
import { BaseButton, ButtonProps, Stack, Text } from '../../../vanilla'
import { useBonusCard } from '../../../store/hooks/useBonusCard'
import { useIntl } from 'react-intl'
import { useGlobalStore } from '../../../store/hooks/useStore'
export interface CheckoutButtonProps extends ButtonProps {
  submitOrderProcess: (isBonusCard?: boolean) => Promise<void | null>
}

export const BonusCardCheckoutButton = (props: CheckoutButtonProps) => {
  const {
    submitOrderProcess,
    ...rest
  } = props

  const { balance } = useBonusCard(true)
  const { formatNumber } = useIntl();
  const { currency } = useGlobalStore()

  return (
    <Stack {...rest}>
      <Text variant="text6">{`Available Balance: ${formatNumber(Number(balance), { style: 'currency', currency })}`}</Text>
      <BaseButton
        variant="primary"
        width="full"
        onClick={() => submitOrderProcess(true)}
      >
        Pay with Bonus Card
      </BaseButton>
    </Stack>
  )
}
